import React from 'react';

let Footer = (props) => {

    return (
        <footer id="footer">
        <div className="container">
           <p>            
                <small>Common Vulnerabilities and Exposures (CVE) is a catalog of known security threats. 
                The catalog is sponsored by the United States Department of Homeland Security (DHS). </small>             
            </p>
        </div>
      </footer>       
    )
}

export default Footer;